const Joi = require("joi");

const changePasswordSchema = (data) => {
  const schema = Joi.object({
    oldPassword: Joi.string()
      // .pattern(new RegExp("^[a-zA-Z0-9]+$"))
      // .pattern(
      //   new RegExp(
      //     "^[A-Za-z\\d~!@#$%^&*()_+{}|:\\\"<>?\\[\\]\\\\\\-=\\;',./\\s]{8,}$"
      //   )
      // )
      .pattern(
        new RegExp(/^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/)
      )
      .required()
      // .max(30)
      .messages({
        "string.pattern.base": "Please enter valid Password.",
        // "string.max": "User Password must be less than 30 characters",
        "any.required": "Please enter Password.",
        "string.empty": "Please enter Password.",
      }),

    password: Joi.string()
      // .pattern(new RegExp("^[a-zA-Z0-9]+$"))
      // .pattern(
      //   new RegExp(
      //     "^[A-Za-z\\d~!@#$%^&*()_+{}|:\\\"<>?\\[\\]\\\\\\-=\\;',./\\s]{8,}$"
      //   )
      // )
      .pattern(
        new RegExp(/^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()\[\]-]{8,50}$/)
      )
      .required()
      // .max(30)
      .messages({
        "string.pattern.base": "Please enter valid Password.",
        // "string.max": "User Password must be less than 30 characters",
        "any.required": "Please enter New Password.",
        "string.empty": "Please enter New Password.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = changePasswordSchema;
